import React, { useMemo } from 'react';
import { textDividerStyles } from './text-divider.styles.esm.js';
import { PrivateText } from '../../text/text.esm.js';

function TextDivider(props) {
  var className = props.className,
    light = props.light,
    children = props.children;
  var classes = useMemo(function () {
    return textDividerStyles({
      className: className,
      light: light
    });
  }, [className, light]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: "csg-tw-text-divider ".concat(classes)
  }, /*#__PURE__*/React.createElement(PrivateText, {
    as: "legend",
    className: "px-2 "
  }, children));
}

export { TextDivider as default };
//# sourceMappingURL=text-divider.esm.js.map
